import { Button, Modal } from "react-bootstrap";
import ButtonLoader from "./ButtonLoader";

const ConfirmationModal = ({
  show = false,
  onConfirm,
  onCancel,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  icon,
  isLoading = false,
  hideCancel = false,
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="p-4 text-center">
        {/* Icon */}
        {icon && (
          <div className="mb-3 d-flex justify-content-center">{icon}</div>
        )}

        {/* Title */}
        <h4
          style={{
            fontWeight: 600,
            color: "#111827",
            marginBottom: 16,
          }}
        >
          {title}
        </h4>

        {/* Description */}
        <p
          style={{
            fontSize: 16,
            lineHeight: "1.6",
            marginBottom: 24,
            fontWeight: 500,
          }}
        >
          {description}
        </p>

        {/* Actions */}
        <div className="d-flex justify-content-center gap-3">
          {cancelText && !hideCancel && (
            <Button
              className="btn btn-light px-4 text-center"
              onClick={onCancel}
              style={{
                fontWeight: 400,
              }}
            >
              {cancelText}
            </Button>
          )}

          <Button
            className="btn btn-light px-4"
            onClick={onConfirm}
            style={{
              backgroundColor: "#112314",
              color: "#ffffff",
              fontWeight: 500,
            }}
            disabled={isLoading}
          >
            {isLoading ? <ButtonLoader color="#fff" /> : confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
